import {
  Consent,
  ConsentPurpose,
  functional,
  performance,
  targeting
} from "cookiesConsent/domain/consent"

export interface C15tConsent {
  hasConsented: boolean
  categories: Record<string, boolean>
}

const purposesByC15tCategory: Record<string, ConsentPurpose> = {
  functionality: functional,
  measurement: performance,
  marketing: targeting
}

const consentFromC15t = (consent: C15tConsent): Consent =>
  new Consent(
    Object.entries(consent.categories)
      .filter(
        ([category, granted]) => granted && purposesByC15tCategory[category]
      )
      .map(([category]) => purposesByC15tCategory[category])
  )

export default consentFromC15t
